import { createSelector } from 'reselect';

export const selectBonusAvailable = state => state.bonusAvailable;

export const selectBonusAvailableConfig = createSelector(
  selectBonusAvailable, ({ config }) => config,
);

export const selectBonusAvailableIsLoaded = createSelector(
  selectBonusAvailable, ({ isLoaded }) => isLoaded,
);

export const selectBonusAvailableIsLoading = createSelector(
  selectBonusAvailable, ({ isLoading }) => isLoading,
);

export const selectBonusAvailablePlacements = createSelector(
  selectBonusAvailable, ({ placements }) => placements,
);

export const selectBonusAvailableButtonPlacement = createSelector(
  [selectBonusAvailablePlacements],
  (placements) => placements.find(({ type }) => type === 'button_install'),
);
